import NP from "./NP";
let numeral = require('numeral');
let moment = require('moment');

NP._currentCulture = null;

NP.getDayFormat = function ()
{
	let res = "";
	if (NP.getCurrentUser() && NP.getCurrentUser().getKey() != -1)
		res = NP.getCurrentUser().getRegionalSettings().DateFormat;

	if (!res || res == 'AutoDF')
	{
		res = "DD MMM YYYY";
	}
	return res;
};

NP.getDayHourFormat = function ()
{
	let regInfo = NP._CurrentUser.getRegionalSettings(),
		is12H = regInfo.Is24HFormat == false;
	return NP.getDayFormat() + (is12H ? " hh:00 A" : " HH:00");
};

NP.getDayTimeFormat = function ()
{
	let regInfo = NP._CurrentUser.getRegionalSettings(),
		is12H = regInfo.Is24HFormat == false;
	return NP.getDayFormat() + (is12H ? " hh:mm A" : " HH:mm");
};

NP.getDayMHourFormat = function ()
{
	return NP.getDayFormat() + " LT";
};

NP.getWeekFormat = function ()
{
	return "MMM Do YYYY";
};

NP.getCurrentCulture = function ()
{
	return NP._currentCulture;
};

NP.setCurrentCulture = function (value: any)
{
	NP._currentCulture = value;
	if (numeral)
		numeral.locale(value.Name);
	if (moment)
		moment.locale(value.Name);
};

NP.RM =
	{
		_localizedControls: [],
		Cultures: [],
		TypicalProps: ['Caption', 'PlaceHolder', 'ToolTip', 'FloatingLabel'],
		getString: function (fieldName: string, key?: string)
		{
			if (NP._currentCulture)
			{
				if (key)
					return NP._currentCulture.Resources[key + '_' + fieldName] || '';
				else
					return NP._currentCulture.Resources[fieldName] || '';
			}
			return '';
		},
		setToCtrl: function (ctrl: any, key: string)
		{
			if (NP._currentCulture)
			{
				let rvalue = NP._currentCulture.Resources[key]
				if (rvalue && ctrl.setContent)
					ctrl.setContent(rvalue);
				for (let i = 0; i < NP.RM.TypicalProps.length; i++)
				{
					rvalue = NP._currentCulture.Resources[key + '_' + NP.RM.TypicalProps[i]];
					if (rvalue && ctrl['set' + NP.RM.TypicalProps[i]])
						ctrl['set' + NP.RM.TypicalProps[i]](rvalue);
				}
			}
		},
	};
